import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PurchaseReport } from './purchase-report';
import { ReportingPeriod } from './reporting-period';
import { ReportsInPeriod } from './reports-in-period';

/**
 * Read reporting period service.
 *
 * @author Warlock, AIS.PL
 */
@Injectable({
  providedIn: 'root'
})
export class ReadReportingPeriodService {

  constructor(private http: HttpClient) {
  }

  readReportingPeriods(year: number, dealerId?: number): Observable<ReportingPeriod[]> {
    const url = 'dealers/' + (dealerId ? dealerId : 'mine') + '/reporting-periods/' + year + '/';
    return this.http
      .get(url, {
        headers: { 'Content-Type': 'application/json' }
      })
      .pipe(
        map(response => response ? (response as any[]).map(element => ReportingPeriod.fromJSON(element)) : null)
      );
  }

  getReportsByWeek(startDate: Date, dealerId?: number): Observable<ReportsInPeriod> {
    const url = `dealers/${(dealerId ? dealerId : 'mine')}/reports/${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()}/`;

    return this.http
      .get<ReportsInPeriod>(url, {
        headers: { 'Content-Type': 'application/json' }
      })
      .pipe(
        map(response => {
          response.period = response.period ? ReportingPeriod.fromJSON(response.period) : null;
          response.reports = response.reports ? response.reports.map(element => PurchaseReport.fromJSON(element)) : null;

          return response;
        })
      );
  }

}
